<template>
  <b-navbar
    type="light"
    toggleable="md"
    fixed="top"
    v-b-scrollspy:nav-scroller
    class="header-area"
    :class="{ 'is-sticky': scrolled }"
  >
    <div class="container-fluid container-fluid--cp-150 removeGradient">
      <!-- navbar collapse -->
      <b-navbar-toggle class="toggler" target="nav_collapse"></b-navbar-toggle>
      <!-- Navbar Logo -->
      <b-navbar-brand class="navbar-brand" to="/"
        ><img
          class="small"
          src="https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Flogo%2Flogo.svg?alt=media&token=16113781-34c0-4e2b-bbec-cc66d05350c9"
          alt="logo"
      /></b-navbar-brand>
      <!-- language button  -->
      <!-- <b-btn-group class="header-config-wrapper">
         component for toggeling languages -->
      <!-- <appToggleLang />
      </b-btn-group>   -->
      <!-- <div v-if="!mobile" class=""> -->
      <b-btn-group class="header-config-wrapper" v-if="!mobile">
        <appToggleLang />
      </b-btn-group>
      <!-- </div> -->
      <div v-else></div>

      <!-- items can be smaller  in mobile  -->

      <b-collapse
        class="default-nav justify-content-center"
        is-nav
        id="nav_collapse"
      >
        <b-navbar-nav class="navbar-nav main-menu">
          <b-nav-item href="#Home" class="scroll" data-aos="fade-down"
            ><span style="color: white">{{
              i18n("navbar.home")
            }}</span></b-nav-item
          >
          <b-nav-item
            href="#about"
            class="scroll"
            data-aos="fade-down"
            data-aos-delay="200"
            ><span style="color: white">{{
              i18n("navbar.about")
            }}</span></b-nav-item
          >
          <b-nav-item
            href="#services"
            class="scroll"
            data-aos="fade-down"
            data-aos-delay="400"
            ><span style="color: white">{{
              i18n("navbar.services")
            }}</span></b-nav-item
          >
          <b-nav-item
            href="#contact"
            class="scroll"
            data-aos="fade-down"
            data-aos-delay="600"
            ><span style="color: white">{{
              i18n("navbar.contactUs")
            }}</span></b-nav-item
          >
          <!-- <b-nav-item   > -->
          <!-- <b-btn-group class="header-config-wrapper"> -->
          <!-- component for toggeling languages -->
          <div v-if="mobile">
            <b-btn-group>
              <appToggleLang />
            </b-btn-group>
          </div>
          <div v-else></div>

          <!-- <appToggleLang /> -->

          <!-- <b-btn-group v-else>
            <appToggleLang />
          </b-btn-group> -->
          <!-- </b-btn-group> -->
          <!-- </b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import appToggleLang from "./LangToggleBtn";
export default {
  name: "Navbar",
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
      currWidth: document.documentElement.clientWidth,
    };
  },

  methods: {
    // sticky menu script
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },
    resizeHandler() {
      this.currWidth = document.documentElement.clientWidth;
    },

    // translation
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.resizeHandler);
  },
  components: {
    appToggleLang,
  },
  computed: {
    mobile() {
      return this.currWidth <= 768;
    },
  },
};
</script>
<style lang="scss">
.removeGradient {
  background-image: linear-gradient(45deg, transparent, transparent);
}
.navbar-brand {
  margin-right: 0 !important;
}
.small {
  @media only screen and (max-width: 300px) {
    width: 86px !important;
  }
}
.toggler {
  display: flex;
  margin-left: auto;
}
[dir="rtl"] .toggler {
  margin-right: auto;
  margin-left: unset !important;
}
.header-config-wrapper {
  order: 4 !important;
}
.nav-item:hover {
  .nav-link span {
    // border-bottom: 1px solid white;
    transition: border 1s ease !important;
  }
}

.add-border {
}

[dir="rtl"] .navbar-nav {
  text-align: right;
}
</style>
